import { getController as getDataSourceController } from './DataSource';
import { getMethods as getSettingsMethods } from './Settings';
import { getMethods as getProjectManagerMethods } from './ProjectManager';
import { getMethods as getIntegrationManagerMethods } from './IntegrationManager';
import { getMethods as getUniqueIdCreatorMethods } from './UniqueIdCreator';
import { getMethods as getDocumentManagerMethods } from './DocumentManager';
import { getMethods as getActionMethods } from './Action';

const getController = (service: 'Studio') => ({
	DataSource: getDataSourceController(service),
	Settings: getSettingsMethods(service, 'Settings'),
	ProjectManager: getProjectManagerMethods(service, 'ProjectManager'),
	DeleteProjectSourceCode: getProjectManagerMethods(service, 'DeleteProjectSourceCode'),
	EncryptProject: getProjectManagerMethods(service, 'EncryptProject'),
	IntegrationManager: getIntegrationManagerMethods(service, 'IntegrationManager'),
	UniqueIdCreator: getUniqueIdCreatorMethods(service, 'UniqueIdCreator'),
	DocumentManager: getDocumentManagerMethods(service, 'DocumentManager'),
	Action: getActionMethods(service, 'Action')
});

export { getController };
